import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

export const papi = axios.create({ baseURL: `${BASE}/api/portal` });

papi.interceptors.request.use((config) => {
  const token = localStorage.getItem("rcs_portal_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const portalLogout = () => {
  localStorage.removeItem("rcs_portal_token");
};

export const errText = (err, fallback) => {
  const d = err.response?.data?.detail;
  return typeof d === "string" ? d : fallback;
};

export const localISO = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const mondayOf = (dateStr) => {
  const d = new Date(`${dateStr}T00:00:00`);
  d.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  return localISO(d);
};
